export function isOdd(number: number) {
  return number % 2 !== 0;
}

export function isEven(number: number) {
  return number % 2 === 0;
}
